import axios from '../helpers/axios'
import { logError } from '../services';
import { ICountiesResponse, IResponseError, IStateRes } from '../models';

export const getCounties = async (filters?: {
  page?: number;
  perPage?: number;
  sortBy?: string;
  stateAbbreviation?: string;
}): Promise<ICountiesResponse> => {
  try {
    const { data } = await axios.get(`/api/counties`, { params: filters });
    return data;
  } catch (error) {
    logError(error, 'getCounties failed');
    return Promise.reject(error);
  }
};

export const putCounty = async (
  state,
  name,
  taxRate
): Promise<ICountiesResponse & IResponseError> => {
  try {
    const { data } = await axios.put(`/states/${state}/counties/${name}`, { taxRate });
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: {
          state,
          name,
          taxRate
        }
      },
      'putCounty failed'
    );
    return Promise.reject(error?.response?.data);
  }
};

export const postCounty = async (state, name, taxRate): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/counties`, { state, name, taxRate });
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: {
          state,
          name,
          taxRate
        }
      },
      'postCounty failed'
    );
    return Promise.reject(error?.response?.data);
  }
};

export const deleteCounty = async (state, name): Promise<any> => {
  try {
    const { data } = await axios.delete(`/states/${state}/counties/${name}`);
    return data;
  } catch (error) {
    logError(error, 'deleteCounty failed');
    return Promise.reject(error);
  }
};

export const getStates = async (): Promise<IStateRes> => {
  try {
    const { data } = await axios.get('/api/states');
    return data;
  } catch (error) {
    logError(error, 'getStates failed');
    return Promise.reject(error);
  }
};
